module.exports = __webpack_public_path__ + "static/media/Roboto.8a36205b.ttf";